import { IContactInfo } from "@hopper-b2b/checkout";
import { PassengerTypes } from "@hopper-b2b/types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ActionButton } from "@hopper-b2b/ui";
import {
  Airport,
  FareDetailsV2,
  PriceFreezeOfferData,
  TripDetailsV2,
} from "@b2bportal/price-freeze-api";

import { PriceFreezeOfferCard } from "../../components/PriceFreezeOfferCard";
import { PriceFreezeDurationSlider } from "../../components/PriceFreezeDurationSlider";
import { DescriptionBlock } from "../../components/DescriptionBlock";
import { TermsOfServiceBlock } from "../../components/TermsOfService";
import { ContactInformationBlock } from "../../components/ContactInformationBlock";
import { DetailsBlock } from "../../components/DetailsBlock";
import Lock from "./lock.svg";
import "./styles.scss";
import { CheckoutBanner } from "../../components";

export interface IPriceFreezeOfferPage {
  tripDetails: TripDetailsV2;
  bannerTitle: string;
  bannerSubtitle: string;
  flightPricePerPaxText: string;
  priceFreezeOfferPricePerPaxText: string;
  priceFreezeTotalAmount: string;
  offerData: PriceFreezeOfferData[];
  selectedOfferDataIndex: number;
  selectedOfferData: PriceFreezeOfferData;
  handleContactInfoChange: (val: IContactInfo) => void;
  contactInfo: IContactInfo;
  canContinueToPayment: boolean;
  passengerMap: { [key in PassengerTypes]?: number };
  fareDetails: FareDetailsV2;
  onPassengerCountChange: (val: { [key in PassengerTypes]?: number }) => void;
  onNextClick: () => void;
  handleDurationChange: (val: number) => void;
  offerCapAmount: string;
  airports?: { [key: string]: Airport };
  assets?: Record<string, any>;
}

export const PriceFreezeOfferPage = ({
  tripDetails,
  assets,
  // BANNER
  bannerTitle,
  bannerSubtitle,
  // OFFERCARD
  flightPricePerPaxText,
  priceFreezeOfferPricePerPaxText,
  selectedOfferDataIndex,
  selectedOfferData,
  // SLIDER
  offerData,
  handleDurationChange,
  //TOS,
  offerCapAmount,
  //CONTACT INFO
  handleContactInfoChange,
  contactInfo,
  //DETAILS
  passengerMap,
  onPassengerCountChange,
  fareDetails,
  priceFreezeTotalAmount,
  airports,
  //NEXT STEP
  canContinueToPayment,
  onNextClick,
}: IPriceFreezeOfferPage) => {
  const { t } = useI18nContext();

  return (
    <div className="price-freeze-purchase-offer checkout-page">
      <CheckoutBanner
        title={bannerTitle}
        subtitle={bannerSubtitle}
        icon={Lock}
      />
      <PriceFreezeOfferCard
        {...{
          message: `${t("priceFreezePurchase.offerCard.title")}`,
          frozenFlightPrice: `${flightPricePerPaxText}/${t(
            "priceFreezePurchase.offerCard.traveler"
          )}`,
          priceFreezePrice: `${priceFreezeOfferPricePerPaxText}/${t(
            "priceFreezePurchase.offerCard.traveler"
          )}`,
          priceFreezeSecondsTtl: selectedOfferData?.secondsTtl,
        }}
      >
        <PriceFreezeDurationSlider
          handleDurationChange={handleDurationChange}
          priceFreezeOfferData={offerData}
          selectedPriceFreezeOfferIndex={selectedOfferDataIndex}
        />
      </PriceFreezeOfferCard>
      <DescriptionBlock capAmount={offerCapAmount} />
      <ContactInformationBlock
        onContactInfoChange={handleContactInfoChange}
        contactInfo={contactInfo}
      />
      <DetailsBlock
        passengerMap={passengerMap}
        onPassengerCountChange={onPassengerCountChange}
        tripDetails={tripDetails}
        fareDetails={fareDetails}
        priceFreezeTotalAmount={priceFreezeTotalAmount}
        airports={airports}
        assets={assets}
      />
      <TermsOfServiceBlock clientAssets={assets} />
      <div className="checkout-button-container">
        <ActionButton
          disabled={!canContinueToPayment}
          onClick={() => onNextClick()}
          message={t("priceFreezePurchase.offerCard.continueToPayment")}
        />
      </div>
    </div>
  );
};
